import React, { useEffect, useState } from "react";
import {
  collection,
  limit,
  onSnapshot,
  orderBy,
  query,
} from "firebase/firestore";
import { ReactComponent as DropdownIcon } from "../../../../assets/icons/paraplanningDashboard/ArrowDropdown.svg";
import { db } from "../../../../backend/firebaseConfig";
import { PostCard } from "../HelperFunctions/HelperFunctions";
import "../../../../css/Adviser/AdviserDetailsPage.css";

const FIELD_LABELS = {
  ioAdviserId: "IO Adviser ID",
  id: "id",
  groupId: "group.id",
  userId: "user.id",
};

const formatDateTime = (value) => {
  if (!value) return "-";

  const date = value?.toDate ? value.toDate() : new Date(value);
  if (Number.isNaN(date.getTime())) return "-";

  return date.toLocaleString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

const formatValue = (value) =>
  value === "" || value === null || value === undefined ? "-" : String(value);

export default function IOEditLogs({ adviserEmail }) {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!adviserEmail || !open) {
      setLogs([]);
      return undefined;
    }

    setLoading(true);
    const logsQuery = query(
      collection(
        db,
        "Authorized Members",
        "Advisers",
        "Data",
        adviserEmail,
        "IO Details",
        "Data",
        "Edit Logs",
      ),
      orderBy("editedAt", "desc"),
      limit(50),
    );

    return onSnapshot(
      logsQuery,
      (snapshot) => {
        setLogs(
          snapshot.docs.map((logSnapshot) => ({
            id: logSnapshot.id,
            ...logSnapshot.data(),
          })),
        );
        setLoading(false);
      },
      (error) => {
        console.error("Failed to load IO edit logs:", error);
        setLogs([]);
        setLoading(false);
      },
    );
  }, [adviserEmail, open]);

  return (
    <PostCard
      title="Edit Logs"
      right={
        <button
          type="button"
          className="table-row-action"
          onClick={() => setOpen((current) => !current)}
          aria-label={open ? "Collapse edit logs" : "Expand edit logs"}
          aria-expanded={open}
          title={open ? "Collapse edit logs" : "Expand edit logs"}
        >
          <DropdownIcon
            aria-hidden
            style={{
              transform: open ? "rotate(180deg)" : "rotate(0deg)",
              transition: "transform 0.2s ease",
            }}
          />
        </button>
      }
    >
      {open ? (
        <>
          {loading ? (
            <p className="Content-Small muted">Loading edit logs...</p>
          ) : null}

          {!loading && logs.length === 0 ? (
            <p className="Content-Small muted">
              No edit logs found yet. New changes will appear here after
              saving.
            </p>
          ) : null}

          {!loading && logs.length > 0 ? (
            <div className="lcEditLogsList">
              {logs.map((log) => (
                <div key={log.id} className="lcEditLogItem">
                  <div className="lcEditLogHeader">
                    <span className="FP_Help_Text_Semibold">
                      {log.updatedByName ||
                        log.updatedBy ||
                        log.editedBy ||
                        "Unknown user"}
                    </span>
                    <span className="FP_Help_Text muted">
                      {formatDateTime(log.updatedAt || log.editedAt)}
                    </span>
                  </div>

                  <div className="lcEditLogChanges">
                    {(log.changes || []).map((change, index) => (
                      <div
                        key={`${log.id}-${change.fieldPath}-${index}`}
                        className="lcEditLogChange"
                      >
                        <div className="FP_Help_Text_Semibold">
                          {FIELD_LABELS[change.fieldPath] || change.fieldPath}
                        </div>
                        <div className="FP_Help_Text">
                          <span className="muted">From:</span>{" "}
                          {formatValue(change.previousValue)}
                        </div>
                        <div className="FP_Help_Text">
                          <span className="muted">To:</span>{" "}
                          {formatValue(change.newValue)}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          ) : null}
        </>
      ) : null}
    </PostCard>
  );
}
